import React from 'react';
import { Typography, cn } from '@kiiwi/ui';
import { useTranslation } from '@/src/i18n';

type Props = {
  size?: 'sm' | 'lg';
  text?: string;
};

const EmptyState = ({ size = 'sm', text }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "relative flex h-40 w-full justify-center bg-[url('/static/icons/not-found.svg')] bg-[length:120px] bg-[center_10px] bg-no-repeat",
        size === 'lg' && 'h-72 bg-[length:240px]',
      )}
    >
      <Typography className="absolute bottom-0 text-center font-semibold text-neutral-primary">
        {text || t('no_teleconsultation_available')}
      </Typography>
    </div>
  );
};

export default EmptyState;
